import React, { Component } from 'react';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { Col, Row, Form, Button, Modal, ModalBody, Input } from 'reactstrap';
import { getAPI, postAPI } from '../Base/API';
import { handleNotification } from "../Base/Common/Notification";
import { StyledCard } from '../Base/Common/CommonUIComponents';
import { getRightVoucherId, getRefundReasons } from '../Base/Common/ReferenceDataFunctions';
import { FormattedMessage, injectIntl } from 'react-intl';
import CustomSelect from '../Base/Common/CustomSelect';

const RefundModal = (props) => {
    const { modal, toggle, selectedVoucher, paymentGateway } = props;

    const [block, setBlock] = React.useState(false);
    const [error, setError] = React.useState([]);
    const [reason, setReason] = React.useState('');
    const [notes, setNotes] = React.useState('');
    const [amount, setAmount] = React.useState(0);

    
    const postRefund = (e) => {
        e.preventDefault();

        setBlock(true);
        let req = {
            "Id": selectedVoucher.id,
            "reason": reason,
            "notes": notes,
            "amount": amount
        }
        postAPI(result => {
            const { data, error } = result;

            if (error) {
                var errorMessage = [];
                errorMessage.push({ message: error.message, stack: error.stack, messageType: 'danger' });
                setError(errorMessage);
                setBlock(false);

                return;
            }
            if (data) {
                if (data.errors && data.errors.length > 0) {
                    handleNotification(data);

                    setBlock(false);
                    return;
                }
                else if (data.response?.length > 0) {
                    handleNotification(data, <FormattedMessage id="OnlineSalesDetail.RefundSuccessfully" />, <FormattedMessage id="OnlineSalesDetail.Success" />);
                    props.refreshData();
                    toggle();
                    setBlock(false);
                }
            }
        }, '/api/Voucher/Payment/v1/Refund', req);
    }

    return (
        <Modal isOpen={modal} toggle={toggle} fade={false} className="modal-lg" >
            <ModalBody className="modal-lg p-0">
                <StyledCard title={'OnlineSalesDetail.Refund'} block={block} error={error} >
                    <Form onSubmit={postRefund} >
                        <Row className="mb-3">
                            <Col>
                                <b>
                                    <FormattedMessage id="OnlineSalesDetail.Voucher" />
                                    <span className='pl-2'>{selectedVoucher && getRightVoucherId(selectedVoucher.voucherId, selectedVoucher.voucherIdFirst8)}</span>
                                </b>
                            </Col>
                            <Col className="text-right">
                                <Button className="btn-sm btn-host" type="submit" ><i className="fa-solid fa-floppy-disk"></i></Button>
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col className="col-3"><FormattedMessage id="OnlineSalesDetail.RefundAmount" /></Col>
                            <Col>
                                <Input
                                    type="number" 
                                    onChange={(e) => setAmount(e.target.value)}
                                    required
                                    placeholder={props.intl.formatMessage({ id: "OnlineSalesDetail.RefundAmount" })}
                                    min="0.01" 
                                    max={selectedVoucher && selectedVoucher.salePrice} 
                                    step="0.01"
                                />
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col className="col-3"><FormattedMessage id="OnlineSalesDetail.Reason" /></Col>
                            <Col>
                                <CustomSelect 
                                    options={getRefundReasons(paymentGateway)} 
                                    isClearable 
                                    required
                                    value={getRefundReasons(paymentGateway).find(el => el.value === reason)} 
                                    name="reason"
                                    onChange={(e) => setReason(e ? e.value : '')} 
                                    placeholder={<FormattedMessage id="OnlineSalesDetail.Reason" />} 
                                />
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col className="col-3"><FormattedMessage id="OnlineSalesDetail.Notes" /></Col>
                            <Col> 
                                <Input 
                                    type="textarea" 
                                    onChange={(e) => setNotes(e.target.value)} 
                                    required 
                                    placeholder={props.intl.formatMessage({ id: "OnlineSalesDetail.Notes" })} 
                                    minLength="10"
                                    maxLength="200" 
                                />
                            </Col>
                        </Row>
                    </Form>
                </StyledCard>
            </ModalBody>
        </Modal>
    );
}

export default injectIntl(RefundModal);